import {Inject, Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {APP_CONFIG, AppConfig} from "../../../config/app.config";
import {
  AviaSearchAppliedFiltersRequest,
  AviaSearchFiltersResponse,
  AviaSearchRequest,
  AviaSearchResponse,
  AviaSearchResult
} from "../interfaces/avia-search";
import {AviaSearchService} from "../avia-search.service";
import {SuggestHotel} from "../../../models";
import {AviaDetailsResponse} from "../interfaces/avia-details";

@Injectable({providedIn: 'root'})
export class RouterRequestService {
  private readonly host: string;

  constructor(
    private http: HttpClient,
    private searchService: AviaSearchService,
    @Inject(APP_CONFIG) private appConfig: AppConfig,
  ) {
    this.host = appConfig.searchAviaUrl;
  }

  startSearch(request: AviaSearchRequest): Observable<AviaSearchResponse> {
    const headers = this.searchService.getHeaders();
    return this.http.post<AviaSearchResponse>(
      `${this.host}/search`,
      {...request},
      {headers}
    );
  }

  getAvia(searchID: string, request: AviaSearchAppliedFiltersRequest | {} = {}) {
    const headers = this.searchService.getHeaders();
    const params: Record<string, string> = {};
    const sortBy = 'sortBy' in request ? request.sortBy : undefined;
    const page = 'page' in request ? request.page : undefined;
    const body = 'filters' in request
      ? {filters: request.filters}
      : request;

    if (sortBy) {
      params['sortBy'] = sortBy;
    }

    if (page) {
      params['page'] = String(page);
    }

    return this.http
      .post<AviaSearchResult>(
        `${this.host}/search/${searchID}`,
        body,
        {headers, params}
      );
  }

  getAviaFilters(searchId: string): Observable<AviaSearchFiltersResponse> {
    const headers = this.searchService.getHeaders();

    return this.http.post<AviaSearchFiltersResponse>(
      `${this.host}/search/${searchId}/filters`,
      {headers}
    );
  }

  getAviaDetails(offerId: string, searchId?: string) {
    const headers = this.searchService.getHeaders();

    const params = searchId ? {searchId} : undefined;

    return this.http.get<AviaDetailsResponse>(`${this.host}/offers/${offerId}`, {headers, params});
  }
}
